export default "__VITE_ASSET__D$XLeoCz__"